const MicrowaveIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 21.5 16.5"
    fill="none"
    {...props}
  >
    <path
      d="M15.4595 3.31519H17.9194V4.45435H15.4595V3.31519Z"
      fill="currentColor"
    />
    <path
      d="M17.9113 7.07019H17.9194M15.4595 7.07019H15.4676M17.9113 9.42981H17.9194M15.4595 9.42981H15.4676M0.75 2.75L0.75 13.75C0.75 14.2804 0.960714 14.7891 1.33579 15.1642C1.71086 15.5393 2.21957 15.75 2.75 15.75L18.75 15.75C19.2804 15.75 19.7891 15.5393 20.1642 15.1642C20.5393 14.7891 20.75 14.2804 20.75 13.75V2.75C20.75 2.21957 20.5393 1.71086 20.1642 1.33579C19.7891 0.960714 19.2804 0.750001 18.75 0.750001L2.75 0.75C2.21957 0.75 1.71086 0.960714 1.33579 1.33579C0.960715 1.71086 0.75 2.21957 0.75 2.75ZM3.39612 3.31519H12.7522V13.2666H3.39612V3.31519ZM15.4595 3.31519H17.9194V4.45435H15.4595V3.31519Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MicrowaveIcon;
